import { Box, Button, Typography } from "@material-ui/core";
import React from "react";
import "./style.css";

interface Props{
    entityName:string;
    closeModal:()=>void;
    removeUser:()=>Promise<void>;
}

export const RemoveEntityModalContent = ({entityName,closeModal,removeUser}:Props)=>{
    return(
        <>
            <Box padding="2em">
                <Box display="flex" justifyContent="center">
                    <Typography variant="h4" gutterBottom >
                        {`Are you sure you want to remove ${entityName}?`}
                    </Typography>
                </Box>
                <Box display="flex" justifyContent="center" padding="2em">
                    <Typography variant="h6" className="base-color">
                        {`All information about the ${entityName} will be completely remove
                        from the system`}
                </Typography>
                </Box>
                <Box display="flex" justifyContent="space-evenly" >
                    <Button className="entity-remove-button delete-entity-modal-buttons" onClick={removeUser}>Remove</Button>
                    <Button className="entity-cancel-button delete-entity-modal-buttons" onClick={closeModal}>Cancel</Button>
                </Box>
            </Box>
        </>
    )
}